import { useCPNavigation } from '@common/navigation-layer/composables/useNavigationContext'

/** Page middleware: `/affiliates` always lands on the campaign list. */
export function affiliatesIndexPageRedirectMiddleware() {
  const { CPNavigateTo } = useCPNavigation()
  return CPNavigateTo({
    name: 'clientportal-affiliates-campaign',
    options: { replace: true },
  })
}
